import { Dimensions, StyleSheet } from 'react-native';

const screenHeight = Dimensions.get('window').height;

export default StyleSheet.create({
  timelineBarsScrollView: height => ({
    minHeight: screenHeight > height ? screenHeight : height,
  }),
});
